<div class="nav-bar-ucp">
    <div class="nav-bar-ucp__inner">

        <div class="nav-bar-ucp__row row">

            <div class="nav-bar-ucp__col col -left" *ngIf="(showCollectionTypeToggle$ | async) === true">
                <shared-collection-type-toggle></shared-collection-type-toggle>
            </div>

            <div class="nav-bar-ucp__col col -left">
                <shared-cart-location-button class="nav-bar-ucp__link -for-location"></shared-cart-location-button>
            </div>

            <div class="nav-bar-ucp__col col -right">
                <div class="nav-bar-ucp__row row">

                    <div class="nav-bar-ucp__col col -for-user">
                        <shared-auth-link class="nav-bar-ucp__link"></shared-auth-link>
                    </div>

                    <div class="nav-bar-ucp__col col -for-cart" *ngIf="showCart">
                        <shared-cart-button class="nav-bar-ucp__btn -type-cart -screen-lg">
                        </shared-cart-button>
                    </div>

                </div>
            </div>

        </div>

    </div>
</div>